<script setup>
import { computed, reactive, ref, inject, onBeforeUnmount, onMounted } from 'vue'
const props = defineProps({
  sublist: { type: Array, default: () => [] },
  size: { type: String, default: null }
})
const state = reactive({
  selected_nav: ''
})
const anchorRef = ref()
const categoryRef = ref([])
const width = inject('width')
const isMobile = computed(() => ['s', 'xs'].includes(props.size))

const scrollTo = (id) => {
  const customOffset = isMobile.value ? 85 : 65 + 3
  const element = document.getElementById(`tvb-category-model-${id}`)
  if (element) {
    // 计算最终位置（元素位置 - 自定义偏移）
    const offsetTop = element.offsetTop - customOffset - anchorRef.value.offsetHeight

    // 使用原生滚动
    document.documentElement.scrollTo({
      top: offsetTop,
      behavior: 'instant'
    })
  }
  handleAnchorClick(id)
}
// 描點居中
const handleAnchorClick = (id) => {
  state.selected_nav = id
  const anchorBtn = document.getElementById(`anchor-btn-${id}`)
  if (anchorRef.value.scrollWidth > width.value && anchorBtn) {
    anchorRef.value.scrollLeft = anchorBtn.offsetLeft - width.value / 2 + anchorBtn.offsetWidth / 2
  }
}
// 描點狀態更新
const updateActiveAnchor = (id) => {
  let parts = id.split('-')
  let categoryId = parts[parts.length - 1]
  handleAnchorClick(categoryId)
}

// 監聽滚动
const intersectionObserver = new IntersectionObserver((entries) => {
  if (entries[0].intersectionRatio <= 0 || entries.length > 1) {
    return
  }
  updateActiveAnchor(entries[0].target.id)
})
const observe = () => {
  categoryRef.value = document.querySelectorAll('.tvb-category-model')
  categoryRef.value.forEach((el) => {
    intersectionObserver.observe(el)
  })
}
const unobserve = () => {
  categoryRef.value.forEach((el) => {
    intersectionObserver.unobserve(el)
  })
}
const disconnect = () => {
  unobserve()
  intersectionObserver.disconnect() // 關閉
}
onBeforeUnmount(disconnect)
onMounted(observe)
</script>

<template>
  <div class="main-category-anchor" ref="anchorRef" :class="size ? 'anchor-' + size : ''">
    <div class="anchor-space">
      <template v-for="item in sublist" :key="item.id">
        <button
          @click="scrollTo(item.id)"
          class="anchor-btn"
          :class="{ selected: state.selected_nav == item.id }"
          :id="`anchor-btn-${item.id}`"
        >
          {{ item.title }}
        </button>
      </template>
      <span class="anchor-right"></span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main-category-anchor {
  --an-top: 64px;
  --an-space-top: 2px;
  --an-font-size: 17px;
  --an-ling-height: 26px;
  --an-space-gap: 16px;
  --an-space-bottom: 16px;
  --anchor-right-width: 0;
  --an-letter-spacing: 0.5px;
  background-color: red;
  position: sticky;
  top: var(--an-top);
  padding-top: var(--an-space-top);
  padding-bottom: var(--an-space-bottom);
  width: 100%;
  max-width: var(--tvb-article-max-width);
  overflow: auto;
  margin: 0 auto;
  z-index: 10;
  background: #fff;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
  .anchor-space {
    display: flex;
    flex-wrap: nowrap;
    gap: var(--an-space-gap);
    .anchor-right {
      padding-left: calc(var(--tvb-main-left) - var(--an-space-gap));
    }
  }
  .anchor-btn {
    color: #231f20;
    font-size: var(--an-font-size);
    line-height: var(--an-ling-height);
    border-radius: 12px;
    background: #f5f6f7;
    padding: 6px 16px;
    font-weight: 400;
    letter-spacing: var(--an-letter-spacing);
    border: none;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    outline: 0.5px solid rgba(163, 178, 188, 0.35);
    &:hover {
      background: #eceff3;
    }
    &.selected {
      color: #fff;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%), #231f20;
    }
    &:last-child {
      margin-right: var(--tvb-main-left);
    }
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    --an-top: calc(64px + 46px);
  }

  &.anchor-s,
  &.anchor-xs {
    --an-top: 86px;
    --an-space-top: 6px;
    --an-font-size: 14px;
    --an-ling-height: 20px;
    --an-space-gap: 10px;
    --an-space-bottom: 12px;
    --anchor-right-width: 2px;
    --an-letter-spacing: 0.3px;
    width: calc(100% + var(--tvb-main-left) * 2);
    margin-left: calc(-1 * var(--tvb-main-left));
    margin-right: calc(-1 * var(--tvb-main-left));
    padding-left: var(--tvb-main-left);
    padding-right: var(--tvb-main-left);
    .anchor-btn {
      :last-child {
        margin-right: var(--tvb-main-left);
      }
    }
  }
}
</style>
